import type {
  BouncesListParams,
  BouncesListResult,
  ResendBounceResult,
} from "@/interfaces/reportsBounces";
import { apiClient } from "@/lib/apiClient";

/**
 * GET /reports/bounces -- the Bounces report's ONE endpoint: paginated, searchable, filterable,
 * sortable bounced-recipient rows, plus the campaign filter options when `includeFilterOptions`
 * is set.
 */
export async function fetchBounces(params?: BouncesListParams): Promise<BouncesListResult> {
  const query: Record<string, string | number> = {};
  if (params?.search) query.search = params.search;
  if (params?.campaign_id?.length) query.campaign_id = params.campaign_id.join(",");
  if (params?.recipient_name) query.recipient_name = params.recipient_name;
  if (params?.recipient_email) query.recipient_email = params.recipient_email;
  if (params?.sortBy) query.sortBy = params.sortBy;
  if (params?.sortDir) query.sortDir = params.sortDir;
  if (params?.page && params.page > 1) query.page = params.page;
  if (params?.limit) query.limit = params.limit;
  if (params?.includeFilterOptions) query.includeFilterOptions = "true";

  const { data } = await apiClient.get<BouncesListResult>("/reports/bounces", { params: query });
  return data;
}

/** POST /reports/bounces/:id/resend -- resend the gift to a corrected recipient address. */
export async function resendBounce(
  contactId: number,
  body: { newEmail: string },
): Promise<ResendBounceResult> {
  const { data } = await apiClient.post<ResendBounceResult>(
    `/reports/bounces/${contactId}/resend`,
    body,
  );
  return data;
}
